import { cva } from 'class-variance-authority';

// NOTE: overflow-hidden is used as a workaround for the focus outline on keyboard navigation having a weird protrusion at the top
export const flag = cva(
  'border-color-text-dark inline-flex items-center overflow-hidden rounded-sm border',
  {
    variants: {
      size: {
        large: 'px-1',
        normal: 'px-0.5',
        small: 'px-0.5',
      },
    },
    defaultVariants: {
      size: 'normal',
    },
  },
);

export const label = cva('font-family-efficiency-label', {
  variants: {
    size: {
      large: 'text-size-h2',
      normal: 'text-size-h3',
      small: 'text-size-h5',
    },
  },
  defaultVariants: {
    size: 'normal',
  },
});

export const icon = cva('mr-0.5', {
  variants: {
    size: {
      large: 'h-4 w-4',
      normal: 'h-2 w-2',
      small: 'h-2 w-2',
    },
    type: {
      fuelEfficiency: 'icon-emp-fuel-efficiency',
      wetGrip: 'icon-emp-wet-grip',
      externalRollingNoise: 'icon-emp-external-rolling-noise',
    },
  },
  defaultVariants: {
    size: 'normal',
  },
});
